import { type ReactNode, useState } from "react";

import { Icon } from "~/assets/icons/Icon";

import styles from "./CollapsibleSection.module.scss";

type CollapsibleSectionProps = {
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  rightAction?: ReactNode;
  children: ReactNode;
  className?: string;
};

export const CollapsibleSection = ({
  title,
  subtitle,
  defaultOpen = false,
  rightAction,
  children,
  className,
}: CollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={className}>
      <div className={styles.header}>
        <button
          type="button"
          className={styles.toggle}
          aria-expanded={isOpen}
          onClick={() => setIsOpen((v) => !v)}
        >
          <span
            className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""}`}
          >
            <Icon
              iconName="IconDown"
              color="var(--text-grey)"
              width="1rem"
              height="1rem"
            />
          </span>
          <div>
            <div className={styles.title}>{title}</div>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          </div>
        </button>
        {rightAction}
      </div>

      {isOpen && <div className={styles.content}>{children}</div>}
    </div>
  );
};
